import { Field } from "core/field/FieldService";
import { Operation } from "rfc6902/diff";
import { checkStatus, get, patch, post } from "utils/Service";

import { Report as ReportBlueprint } from "core/blueprint/trajectory/TrajectoryBlueprintService";

const ENDPOINT = "/api/v2/trajectories/";
const REPORTS_SUFFIX = "/reports";
const REPORT_BLUEPRINTS_SUFFIX = "/reportblueprints";

export type ReportValues = {
	[key: string]: string;
};

export type Report = {
	structure: Field[];
	values: ReportValues;
};

export function createTrajectoryReport(
	trajectoryId: number,
	blueprintName: string
): Promise<string> {
	return post(
		`${ENDPOINT}${trajectoryId}${REPORTS_SUFFIX}?blueprintName=${blueprintName}`
	).then(response => {
		if (response.status !== 201) {
			throw new Error(response.statusText);
		}

		const location = response.headers.get("location");
		if (location === null) {
			throw new Error("Missing location header!");
		} else {
			return location;
		}
	});
}

export function getTrajectoryReportBlueprints(
	trajectoryId: number
): Promise<ReportBlueprint[]> {
	return get(ENDPOINT + trajectoryId + REPORT_BLUEPRINTS_SUFFIX).then(
		response => response.json()
	);
}

export function getTrajectoryReport(
	trajectoryId: number,
	reportId: number
): Promise<Report> {
	return get(ENDPOINT + trajectoryId + REPORTS_SUFFIX + "/" + reportId).then(
		response => response.json()
	);
}

export function updateTrajectoryReport(
	trajectoryId: number,
	reportId: number,
	patches: Operation[]
): Promise<void> {
	return patch(
		ENDPOINT + trajectoryId + REPORTS_SUFFIX + "/" + reportId,
		patches
	).then(response => checkStatus(response, 200));
}
